import { useState, useEffect } from 'react';
import { blogCategoryAPI } from '../../services/api';

export default function BlogCategoriesAdmin() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [form, setForm] = useState({ name: '', slug: '', description: '', isActive: true, sortOrder: 0 });
    const [formBusy, setFormBusy] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await blogCategoryAPI.getAll();
            setCategories(res.data?.data || res.data || []);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { fetchData(); }, []);

    const slugify = (str) => str.toLowerCase().replace(/[ğ]/g,'g').replace(/[ü]/g,'u').replace(/[ş]/g,'s').replace(/[ı]/g,'i').replace(/[ö]/g,'o').replace(/[ç]/g,'c').replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');

    const openCreate = () => {
        setEditItem(null);
        setForm({ name: '', slug: '', description: '', isActive: true, sortOrder: 0 });
        setShowModal(true);
    };

    const openEdit = (item) => {
        setEditItem(item);
        setForm({ name: item.name || '', slug: item.slug || '', description: item.description || '', isActive: item.isActive, sortOrder: item.sortOrder || 0 });
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormBusy(true);
        try {
            if (editItem) {
                await blogCategoryAPI.update(editItem.id, form);
            } else {
                await blogCategoryAPI.create(form);
            }
            setShowModal(false);
            fetchData();
        } catch (err) {
            alert(err.response?.data?.error || 'Hata oluştu');
        }
        setFormBusy(false);
    };

    const handleDelete = async (id) => {
        if (!confirm('Bu kategoriyi silmek istediğinize emin misiniz?')) return;
        try { await blogCategoryAPI.delete(id); fetchData(); } catch (err) { alert('Silinemedi'); }
    };

    return (
        <div>
            <div className="admin-header">
                <h1>Blog Kategorileri</h1>
                <button className="btn btn-primary" onClick={openCreate}>+ Yeni Kategori</button>
            </div>

            {loading ? <div className="loading"><div className="spinner"></div></div> : (
                <div className="data-table-wrapper">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Ad</th>
                                <th>Slug</th>
                                <th>Sıra</th>
                                <th>Durum</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map(item => (
                                <tr key={item.id}>
                                    <td style={{ fontWeight: 600 }}>{item.name}</td>
                                    <td style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{item.slug}</td>
                                    <td>{item.sortOrder}</td>
                                    <td>
                                        <span className={`stock-badge ${item.isActive ? 'stock-in' : 'stock-out'}`}>
                                            {item.isActive ? 'Aktif' : 'Pasif'}
                                        </span>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                                            <button className="btn-icon" onClick={() => openEdit(item)}>✏️</button>
                                            <button className="btn-icon" onClick={() => handleDelete(item.id)} style={{ color: 'var(--danger)' }}>🗑️</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {categories.length === 0 && (
                                <tr><td colSpan="5" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Henüz blog kategorisi eklenmemiş</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowModal(false)}>
                    <div className="modal" style={{ maxWidth: 500 }}>
                        <div className="modal-header">
                            <h2>{editItem ? 'Kategori Düzenle' : 'Yeni Blog Kategorisi'}</h2>
                            <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Kategori Adı *</label>
                                    <input className="form-control" value={form.name} onChange={e => setForm({ ...form, name: e.target.value, slug: editItem ? form.slug : slugify(e.target.value) })} required />
                                </div>
                                <div className="form-group">
                                    <label>URL Slug</label>
                                    <input className="form-control" value={form.slug} onChange={e => setForm({ ...form, slug: e.target.value })} />
                                </div>
                                <div className="form-group">
                                    <label>Açıklama</label>
                                    <textarea className="form-control" rows={3} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                    <div className="form-group">
                                        <label>Sıra</label>
                                        <input type="number" className="form-control" value={form.sortOrder} onChange={e => setForm({ ...form, sortOrder: parseInt(e.target.value) || 0 })} />
                                    </div>
                                    <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                            <input type="checkbox" checked={form.isActive} onChange={e => setForm({ ...form, isActive: e.target.checked })} /> Aktif
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
                                <button type="submit" className="btn btn-primary" disabled={formBusy}>
                                    {formBusy ? 'Kaydediliyor...' : (editItem ? 'Güncelle' : 'Ekle')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
